<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>最新消息</h1>
        </div>
      </header>
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <article class="public-news-detail-article" v-if="'title' in news">
              <header>
                <div class="mb-4">
                  <span class="public-news-tag mr-2">{{
                    showNewsCategory(news.category)
                  }}</span>
                  <span>{{ news.publishedAt | moment("YYYY年MM月DD日") }}</span>
                </div>
                <h4>{{ news.title }}</h4>
              </header>
              <section
                class="news-html-content"
                v-html="news.content"
              ></section>
            </article>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <router-link class="text-success" to="/">
              <i class="fas fa-chevron-left"></i>
              前往首頁
            </router-link>
            <router-link class="text-success ml-5" to="/news">
              <i class="fas fa-chevron-left"></i>
              前往最新消息
            </router-link>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import db from "../../api/db";
export default {
  name: "PublicNewsDetailScreen",
  components: {
    PublicLayout,
  },
  data() {
    return {
      news: {},
      categoryList: {},
    };
  },
  methods: {
    showNewsCategory(categoryId) {
      return this.categoryList[categoryId].title;
    },
  },
  mounted() {
    const vm = this;
    const newsId = vm.$route.params.newsId;
    async function fetchData() {
      const newsCategoryCollection = await db
        .collection("newsCategoryList")
        .get();
      const categoryList = {};
      newsCategoryCollection.forEach((doc) => {
        const category = doc.data();
        category.id = doc.id;
        categoryList[category.id] = category;
      });
      const doc = await db.doc(`newsList/${newsId}`).get();
      const news = doc.data();
      news.id = doc.id;

      vm.news = news;
      vm.categoryList = categoryList;
    }
    fetchData();
  },
};
</script>